"use strict";
import ApiService from "@/core/services/api.service";

const baseURL = "Camera";

export default {
  startLiveVideo(payload) {
    return new Promise(resolve => {
      ApiService.post(`${baseURL}/StartLiveVideo`, payload).result.then(
        ({ data }) => {
          resolve(data);
        }
      );
    });
  },
  showOneWeekVideo(payload) {
    return new Promise(resolve => {
      ApiService.post(`${baseURL}/ShowOneWeekVideo`, payload).result.then(
        ({ data }) => {
          resolve(data);
        }
      );
    });
  },
  saveVideo(payload) {
    return new Promise(resolve => {
      ApiService.post(`${baseURL}/SaveVideo`, payload).result.then(
        ({ data }) => {
          resolve(data);
        }
      );
    });
  },
  getOldVideoList(payload) {
    return new Promise(resolve => {
      ApiService.post(`${baseURL}/GetOldVideoList`, payload).result.then(
        ({ data }) => {
          resolve(data);
        }
      );
    });
  },
  deleteOldVideo(videoId) {
    return new Promise(resolve => {
      ApiService.delete(`${baseURL}/DeleteOldVideo?videoID=${videoId}`).then(
        ({ data }) => {
          resolve(data);
        }
      );
    });
  }
};
